import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Router from "./routes";
import Confirm from "./components/public/Confirm";
import Header from "./components/newHeader/Header";
import Sidebar from "./components/public/Sidebar";
import Alert from "./components/public/Alert";
import Modal from "./components/public/Modal";
import Loading from "./components/public/Loading";
import PopupFader from "./components/public/PopupFader";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/styles/components/router.scss";
import {
  appDisplayAlert, appSetAlert,
  appSetExpandedNotification,
  appSetExpandedSidebar,
  appSetGuide,
  appSetSendingRequest,
  appSetSettings,
  appSetTogetherQuickAccess,
  appSetWidget
} from "./store/actions/appAction";
import { apiGetAppSettings, apiGetFiscalYears } from "./api/appApi";
import MobileHeader from "components/public/MobileHeader";
import MobileAddInvoiceButton from "components/public/MobileAddInvoiceButton";
import useResponsive from "helpers/useResponsive";
import Guide from "components/public/Guide";
import showGuidHelper from "helpers/showGuideFunction";
import { apiGetNotifications } from "./api/notificationApi";
import { setTableData } from "./store/actions/dataTableAction";
import { selectTableItems, setPagination } from "./store/actions";
import useKeyboardShortcuts from "helpers/useKeyboardShortcuts";
import { navigationShortcuts } from "constants/keyboardConstant";
import { apiGetCurrencies } from "./api/currencyApi";
import { useAppDispatch, useAppSelector } from "store/store";
import { apiGetDashboardGuides, apiGetGuides } from "api/dashboardApi";
import { dicHasval } from "helpers/helper";

export default function App() {
  /* ---------------------------------- Hooks --------------------------------- */
  let navigate = useNavigate();
  let dispatch = useAppDispatch();
  let location = useLocation();
  const { isDesktop } = useResponsive();

  const appState = useAppSelector((state: any) => state.appReducer);
  const paginationReducer = useAppSelector((state: any) => state.paginationReducer);
  const businessState = useAppSelector((state: any) => state.businessReducer)
  const token = useAppSelector((state: any) => state.userReducer.user?.token)

  /* --------------------------------- Routes --------------------------------- */
  // const authRoutes = [
  //   "/auth/login",
  //   "/auth/otp",
  //   "/auth/pwd",
  //   "/auth/rst",
  //   "/auth/nrn",
  //   "/auth/setupAccount",
  //   "/auth/newPassword",
  // ];
  // const setupBusinessRoutes = ["/setupBusiness"];
  // const authCenterRoutes = ["/auth/forgotPassword"];
  // const confirmRoutes = ["/auth/confirmAccount"];
  // const businessRoutes = ["/", "/payback", "/business/extend", "/profile", "/auth/logout"];
  const fullHeight = ["/documentArchive"];
  const authRoutes = ["/auth/login", "/auth/register", "/auth/demo"];
  const authCenterRoutes = ["/auth/forgotPassword"];
  const confirmRoutes = ["/auth/confirmAccount"];
  const businessRoutes = ["/", "/business", "/payback", "/business/extend", "/profile", "/auth/logout"];
  const setupBusinessRoutes = ["/business"];


  /* -------------------------------- Variables ------------------------------- */
  const isAuthRoute = authRoutes.concat(authCenterRoutes).includes(location.pathname);
  const isBusinessSetupRoute = authRoutes.concat(setupBusinessRoutes).includes(location.pathname);
  const isAuthCenterRoute = authCenterRoutes.includes(location.pathname);
  const isBusinessRoute = businessRoutes.includes(location.pathname);
  const isConfirmRoute = confirmRoutes.includes(location.pathname);
  const isFullHeight = fullHeight.includes(location.pathname);
  // const isProfileRoute = location.pathname === "/profile";
  const isAddInovoiceRoute = location.pathname.includes("/factors/add");
  const sidebarExpanded = appState.sidebarExpanded;
  const notificationExpanded = appState?.notificationExpanded;
  const classes = [
    authRoutes.includes(location.pathname)
      ? ""
      : isBusinessSetupRoute
        ? "wrap-style-new-auth"
        : isAuthCenterRoute || isConfirmRoute
          ? "wrap-style-center-auth"
          : !isBusinessRoute
            ? "wrap-router-active"
            : isBusinessRoute
              ? "business-router md:max-w-7xl md:pt-[90px]  "
              : "wrap-router",
    sidebarExpanded ? "expand" : "",
    isFullHeight ? "h-full" : ""
  ].join(" ");
  const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const paramsObj = {};
    //@ts-ignore
    for (let [key, value] of params.entries()) {
      //@ts-ignore
      paramsObj[key] = value;
    }
    return paramsObj;
  };
  /* --------------------------------- Effects -------------------------------- */
  useEffect(() => {
    const queryParams = getQueryParams()
    if (dicHasval(queryParams)) {
      localStorage.setItem("query_Params", JSON.stringify(queryParams))
    }
    businessState?.business?.token && dispatch(apiGetGuides(businessState?.business?.token));
    businessState?.business?.token && dispatch(apiGetCurrencies(token));
    businessState?.business?.token && dispatch(apiGetDashboardGuides(businessState?.business?.token));
  }, []);

  useEffect(() => {
    if (appState.forceLogout) {
      navigate("/auth/logout");
    }
  }, [appState.forceLogout]);

  useEffect(() => {
    businessState?.business?.token && initialData();
    businessState?.business?.token && dispatch(apiGetFiscalYears());
  }, [businessState?.business?.token]);
  useEffect(() => {
    if (businessState.business && businessState.business.token) {
      dispatch(apiGetNotifications(businessState.business.token));
    }
  }, [])
  useEffect(() => {


    dispatch(
      setPagination({
        ...paginationReducer,
        page: 1,
        search: {},
        sort: {}, filters: []
      })
    );
    dispatch(setTableData([]));
    dispatch(selectTableItems([]));
    // dispatch(appDisplayAlert());
    dispatch(appSetSendingRequest(false));
    authenticate();
    send();
  }, [location]);

  /* -------------------------------- Functions ------------------------------- */
  const authenticate = () => {
    if (isAuthRoute) {
      if (appState.user) {
        if (!appState.user.confirm) {
          //   navigate("/auth/otp");
          navigate("/auth/confirmAccount");
        } else if (businessState.business) {
          navigate("/dashboard");
        }
        navigate("/");
      }
    } else if (isBusinessRoute) {
      if (appState.user) {
        if (appState.user.confirm === false) {
          // navigate("/auth/otp");
          navigate("/auth/confirmAccount");
        }
      } else {
        navigate(`/auth/login/${window.location.search}`);
      }
    } else if (isConfirmRoute) {
      if (appState.user) {
        if (appState.user.confirm) {
          navigate("/");
        }
      } else {
        navigate(`/auth/login/${window.location.search}`);
      }
    } else if (isBusinessSetupRoute) {
      if (!appState.user) {
        navigate(`/auth/login/${window.location.search}`);
      }
    } else {
      if (appState.user) {
        if (!appState.user.confirm) {
          //   navigate("/auth/otp");
        } else if (!businessState.business) {
          navigate("/");
        }
      } else {
        navigate(`/auth/login/${window.location.search}`);
      }
    }
  };
  // close Guide
  const closeGuide = () => {
    dispatch(appSetGuide());
  };
  // ===close Guide

  // keyboard shortcut
  const settingData =
    (appState?.appSettings?.keyboardShortcut && JSON.parse(appState?.appSettings?.keyboardShortcut)) || [];

  const initialData = async () => {
    try {
      await apiGetAppSettings({ token: businessState?.business?.token }).then((response) => {
        // const savePersonalShortcut = JSON.parse(response?.data?.settings?.keyboardShortcut) ?? [];
        dispatch(appSetSettings(response?.data.settings));
        response?.data?.settings?.quickAccess &&
          dispatch(appSetTogetherQuickAccess(JSON.parse(response?.data?.settings?.quickAccess)));
        response?.data?.settings?.widgets &&
          dispatch(appSetWidget(JSON.parse(response?.data?.settings?.widgets)));
      });
    } catch (error) {
    }
  };

  // handle what happens on key press
  const handleKey = (val: { key: string; value: string; label: string; route?: string }) => {
    // Perform save action
    if (val.key === "keyboardShortcutBack") {
      navigate(-1);
    } else if (val.key === "keyboardShortcutToggleSidebar") {
      dispatch(appSetExpandedSidebar(!sidebarExpanded));
    } else if (val.key === "keyboardShortcutNotificationsSidebar") {
      dispatch(appSetExpandedNotification(!notificationExpanded));
    } else {
      val.route && navigate(val.route);
    }
  };
  useKeyboardShortcuts([...navigationShortcuts, ...settingData], handleKey);
  //== keyboard shortcut

  // useEffect(() => {
  //     send();
  // }, [location]);

  const send = () => {
    if (window && window.parent) {
      //@ts-ignore
      window?.ReactNativeWebView?.postMessage(location?.pathname);
    }
  };

  /* ----------------------------------- JSX ---------------------------------- */
  return (
    <div className="body">
      {appState.user && !isAuthRoute && !isBusinessSetupRoute && isDesktop ? (
        <Header
          showGuid={
            showGuidHelper({
              guidData: appState?.guideData,
              routePath: location.pathname,
              showDashboardGuide: appState?.showDashboardGuide
            }).isShow
          }
          closeGuide={closeGuide}
          activeGuide={appState.showGuide}
        />
      ) : null}
      {appState.user && !isAuthRoute && !isConfirmRoute && !isDesktop ? (
        <MobileHeader isBusinessRoute={isBusinessRoute} />
      ) : null}
      {appState.user &&
        !isAuthRoute &&
        !isBusinessSetupRoute &&
        !isConfirmRoute &&
        !isDesktop &&
        !isBusinessRoute &&
        !isAddInovoiceRoute ? (
        <MobileAddInvoiceButton />
      ) : null}
      {/*{businessState.business ? <Sidebar/> : null}*/}
      {!isBusinessRoute &&
        appState.user &&
        !isAuthRoute &&
        !isBusinessSetupRoute &&
        !isConfirmRoute &&
        isDesktop ? (
        <Sidebar />
      ) : null}

      {/* <ErrorBoundary> */}
      <div className={classes}>
        {appState.showGuide &&
          appState.user &&
          isDesktop &&
          showGuidHelper({
            guidData: appState?.guideData,
            routePath: location.pathname,
            showDashboardGuide: appState?.showDashboardGuide
          }).isShow && (
            <Guide
              item={
                showGuidHelper({
                  guidData: appState?.guideData,
                  routePath: location.pathname,
                  showDashboardGuide: appState?.showDashboardGuide
                }).item
              }
              onClose={closeGuide}
            />
          )}
        <Router showDashboardGuide={appState.showDashboardGuide} />
      </div>
      {/* </ErrorBoundary> */}

      <Loading show={appState.loading} />
      <PopupFader show={appState.toggle} />
      <Modal show={appState.modalShow} modalProps={appState.modalProps} />
      <Confirm confirm={appState.confirm} sendingRequest={appState.sendingRequest} />
      <Alert
        show={appState.alertDisplay && appState.alertMessage && appState.alertMessage}
        message={appState.alertMessage}
        type={appState.alertType}
      />
    </div>
  );
}
